export default {
  universalModalToggle({commit}) {
    commit('universalModalToggle');
  },
  deleteModalToggle({commit}) {
    commit('deleteModalToggle');
  },
  clearObject({commit}, params) {
    commit('clearObject', params)
  },
  handleToggleModal({commit}) {
    commit('handleToggleModal')
  },
  handleEditData({commit}, params) {
    commit('handleEditData', params)
  },
  handleDeleteData({commit}, params) {
    commit('handleDeleteData', params)
  },
}